import { lazy } from "react";
import { enumPermisosCrediBanco } from "./enumPermisosCrediBanco";

const AppIcons = lazy(() => import("../../components/Base/AppIcons"));

const BaseCrediBanco = lazy(() => import("./BaseCrediBanco"));

const PagoCrediBanco = lazy(() =>
  import("./Views/PagoDatafono/PagoCrediBanco")
);

const listPermissionCrediBanco = Object.values(enumPermisosCrediBanco);

export const listPermissionsCrediBanco = listPermissionCrediBanco;

export const rutasCrediBanco = {
  link: "/credibanco-pdp/pago-datafono",
  label: <AppIcons Logo={"RECARGA_CELULAR"} name="Pago con Datáfono" />,
  component: PagoCrediBanco,
  permission: [enumPermisosCrediBanco.CREDIBANCO_PAGO_DATAFONO],
  
};

export default rutasCrediBanco;
